import { render } from "./PickingListForm.vue?vue&type=template&id=0fbed6c1"
import script from "./PickingListForm.vue?vue&type=script&lang=js"
export * from "./PickingListForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__